import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'app-move-bulk-lead-space',
  imports: [SharedModule, AutoCompleteModule],
  templateUrl: './move-bulk-lead-space.component.html',
  styleUrl: './move-bulk-lead-space.component.scss'
})
export class MoveBulkLeadSpaceComponent {
  @Output() closeDialog = new EventEmitter<void>();
  @Input() tabs: any[] = [];
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<void>();
  leadSpaceList: any[] = [];
  isAdminUser: boolean = false;

  constructor(
    private api: LeadService,
    private messageService: MessageService,
    private localStorage: LocalStorageService
  ) { 
    this.isAdminUser = this.localStorage.isAdminUser();
  }
  selectedLeadSpace: any = {};
  isLoading: boolean = false;
  isAddNewSpace: boolean = false;

  newGroupName: string = '';
  isAddSpaceLoading: boolean = false;

  ngOnInit() {
    this.leadSpaceList = this.tabs.slice(1);

  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleAddNewLeadSpace() {
    this.isAddNewSpace = true;
  }

  handleMoveLead() {

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      lead_id: this.selectedProducts.map((item: any) => item.lead_id),
      lead_space_id: this.selectedLeadSpace,
      old_lead_data: {}
    }

    this.isLoading = true;

    this.api.updateBulkLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Lead moved successfully'
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Something went wrong'
        });
      }
    });


  }

  handleCloseNewLeadSpace() {
    this.isAddNewSpace = false;
  }

  handleAddGroup(event:any) {


    const payload : any = {
      space_name: this.newGroupName,
      organization_id: this.localStorage.getOrganizationId(),
      // user_id: this.localStorage.getUserId(),
    }

    if(!this.isAdminUser){
      payload['user_id'] = this.localStorage.getUserId();
    }

    this.isAddSpaceLoading = true;


    this.api.createLeadSpace(payload).subscribe({
      next: (data) => {
        const tabToAdd = {
          label: this.newGroupName,
          value: data?.id,
          isActive: false,
        }

        this.tabs.push(tabToAdd);
        this.newGroupName = '';
        this.isAddSpaceLoading = false;
        
        this.leadSpaceList.push(tabToAdd);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Space added successfully'
        });

        this.isAddNewSpace = false;
      },
      error: (e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: e.error.message || 'Something went wrong'
        });
        this.isAddSpaceLoading = false;
        console.error(e);
      },
    });


  }

  filterSpaceList(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    console.log("query", query);
    console.log("leadSpaceList", this.leadSpaceList);

    for (let i = 0; i < (this.leadSpaceList as any[]).length; i++) {
      let leadSpace = (this.leadSpaceList as any[])[i];
      if (leadSpace.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(leadSpace);
      }
    }

    this.leadSpaceList = filtered;
  }

}
